const sla_overview = {
	table: {
		dcid: "Rechenzentrum-ID",
		debtor_code: "Debitor-Code",
		hostname: "Hostname",
		name: "VPS-Name",
		node: "Knoten",
		sla: "SLA-Level",
		vmid: "VM-ID",
	},
	title: "SLA-Übersicht",
};

export default sla_overview;
